import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\SourceController::update
* @see app/Http/Controllers/Admin/SourceController.php:495
* @route '/app/sources/{source}/text'
*/
export const update = (args: { source: string | { id: string } } | [source: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/app/sources/{source}/text',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\SourceController::update
* @see app/Http/Controllers/Admin/SourceController.php:495
* @route '/app/sources/{source}/text'
*/
update.url = (args: { source: string | { id: string } } | [source: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { source: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { source: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            source: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        source: typeof args.source === 'object'
        ? args.source.id
        : args.source,
    }

    return update.definition.url
            .replace('{source}', parsedArgs.source.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SourceController::update
* @see app/Http/Controllers/Admin/SourceController.php:495
* @route '/app/sources/{source}/text'
*/
update.patch = (args: { source: string | { id: string } } | [source: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\SourceController::update
* @see app/Http/Controllers/Admin/SourceController.php:495
* @route '/app/sources/{source}/text'
*/
const updateForm = (args: { source: string | { id: string } } | [source: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SourceController::update
* @see app/Http/Controllers/Admin/SourceController.php:495
* @route '/app/sources/{source}/text'
*/
updateForm.patch = (args: { source: string | { id: string } } | [source: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const text = {
    update: Object.assign(update, update),
}

export default text